import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { resetPassword } from "../../actions/authAction";
import setAuthorizationToken from '../../utils/setAuthorizationToken';
import {
    Card,
    Form,
    FormGroup,
    FormFeedback,
    Input,
    Row,
    Col,
    InputGroup,
    Button
} from "reactstrap";

class ResetPassword extends Component {
    constructor() {
        super();
        this.state = {
            password: '',
            password2: '',
            errors: {}
        }
    }

    componentDidMount() {
        console.log('this.props.match.params.token :>> ', this.props.match.params.token);
        setAuthorizationToken(this.props.match.params.token);
    }

    onChange = e =>
        this.setState({
            [e.target.name]: e.target.value
        });

    onSubmit = (e) => {
        e.preventDefault();
        const data = {
            newPassword: this.state.password
        };
        if (this.state.password.length > 7) {
            if (this.state.password === this.state.password2) {
                this.props.resetPassword(data, this.props.match.params.token)
            }
            else {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        message: 'Passwords do not match'
                    }
                })
            }
        }
        else this.setState({
            errors: {
                ...this.state.errors,
                message: 'Password should be at least 8 characters'
            }
        })
    };

    render() {
        const { user } = this.props.auth;
        const { errors } = this.state;
        const invalid = Object.keys(errors).length > 0 && true;
        return (
            <div className="container">
                <Row>
                    <Col md="12">
                        <Card className="card card-container">
                            <Form onSubmit={this.onSubmit} className="form-login">
                                <FormGroup>
                                    <h3 className="text-center text-capitalize">Welcome {user.sub}</h3>
                                    <h4 className="text-center text-muted">Please change your password</h4>
                                    <InputGroup className="mb-3">
                                        <Input
                                            invalid={invalid}
                                            type="password"
                                            name="password"
                                            value={this.state.password}
                                            className="form-control form-border"
                                            placeholder="Enter new password"
                                            onChange={this.onChange}
                                            required
                                        />
                                        <FormFeedback>{errors.message}</FormFeedback>
                                    </InputGroup>
                                    <InputGroup className="mb-3">
                                        <Input
                                            invalid={invalid}
                                            type="password"
                                            name="password2"
                                            value={this.state.password2}
                                            className="form-control form-border"
                                            placeholder="Re-enter password"
                                            onChange={this.onChange}
                                            required
                                        />
                                        <FormFeedback>{errors.message}</FormFeedback>
                                    </InputGroup>
                                    <div className="wrapper text-center">
                                        <Button block color="secondary">Submit</Button>
                                    </div>
                                </FormGroup>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    resetPassword: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps, { resetPassword })(withRouter(ResetPassword));
